import i18n from '../../../i18n';
import {IElement} from '../../../incase-domain/elements';
import {ELEMENT} from '../../../incase-domain/elements/base/ElementTypes';
import {getEmptyElement} from '../../element';

function generateTitleTextImageTemplate(slideId: string): IElement[] {
    const titleText = `<h1 style="text-align: center">${i18n.t('template.text.title')}</h1>`;
    return [
        {
            ...getEmptyElement(slideId, ELEMENT.STATIC_TEXT),
            name: 'Title',
            fitContent: false,
            text: titleText,
            yPosition: 5,
            xPosition: 20,
            width: '60%',
            height: '16%',
        },
        {
            ...getEmptyElement(slideId, ELEMENT.STATIC_TEXT),
            name: 'Text',
            fitContent: false,
            yPosition: 23,
            xPosition: 10,
            width: '38%',
            height: '72%',
        },
        {
            ...getEmptyElement(slideId, ELEMENT.PLACEHOLDER),
            name: 'Image',
            fitContent: false,
            yPosition: 23,
            xPosition: 52,
            width: '38%',
            height: '72%',
        },
    ];
}

export default generateTitleTextImageTemplate;
